import { useIamContext } from './IAmContext'
import { useFetchCustomers, useGetCurrentCustomer } from 'ClientPortal/src/api/Queries/customers'
import { useSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'
import { useEffect, useMemo, useState } from 'react'

export const useCustomerSelection = () => {
    const { user } = useIamContext()
    const [customerIdFromHash, setCustomerIdFromHash] = useState<string | null>(null)
    const { selectedCustomer, setSelectedCustomerObject } = useSelectedCustomer()
    const isAppraiser = user?.role === 'appraiser'
    const isCustomer = user?.role === 'customer'
    const { customers: customersForAppraiser, isCustomersInitialLoading, isGetCustomersError } = useFetchCustomers({ enabled: isAppraiser })
    const { customer } = useGetCurrentCustomer({ enabled: isCustomer, withCustomerIdOfCurrentUser: true, throwOnError: false })

    const customersForSelection = useMemo(
        () => (user?.role === 'appraiser' ? customersForAppraiser : customer?.child_customers || []),
        [user, customersForAppraiser, customer]
    )

    useEffect(() => {
        const hash = window.location.hash

        if (hash) {
            const value = hash.substring(1)
            const params = new URLSearchParams(value)
            const customerId = params.get('customer_uuid')

            if (customerId !== null) {
                setCustomerIdFromHash(customerId)
                window.history.replaceState(null, '', window.location.pathname + window.location.search)
            }
        }
    }, [setCustomerIdFromHash])

    useEffect(() => {
        if (customerIdFromHash) {
            const customerToSelect = customersForSelection.find((customer) => customer.uuid === customerIdFromHash)

            if (customerToSelect !== undefined) {
                setSelectedCustomerObject(customerToSelect, false)
                setCustomerIdFromHash(null)
            }
        }
    }, [customerIdFromHash, customersForSelection, setSelectedCustomerObject])

    useEffect(() => {
        if (customersForSelection.length > 0 && !selectedCustomer) {
            setSelectedCustomerObject(customersForSelection[0])
        }
    }, [customersForSelection, selectedCustomer, setSelectedCustomerObject])

    const setSelectedCustomer = (customerId: string) => {
        const selectedCustomer = customersForSelection?.find((customer) => customer.uuid === customerId)
        selectedCustomer && setSelectedCustomerObject(selectedCustomer)
        window.location.reload()
    }
    return {
        customersForSelection,
        isCustomersInitialLoading,
        isGetCustomersError,
        selectedCustomer,
        setSelectedCustomer,
    }
}
